import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import FluxibleComponent from 'vendor/cnpm/fluxible.v0-4/addons/FluxibleComponent';
import type { Fluxible } from 'vendor/cnpm/fluxible.v0-4/index';

import { loadSimulatorSession } from 'bundles/widget-simulator/actions/WidgetSimulatorActions';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import app from 'bundles/widget-simulator/app';

import 'css!bundles/widget-simulator/styl/all';
import 'css!react-select/dist/react-select.css';
import 'css!react-virtualized-select/styles.css';
import 'css!react-virtualized/styles.css';

class Application extends React.LegacyComponentWithChildren {
  static propTypes = {
    children: PropTypes.node,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof Application.contextTypes>;

  componentDidMount() {
    const { executeAction } = this.context;
    executeAction(loadSimulatorSession);
  }

  render() {
    const { children } = this.props;
    return <div className="rc-Application">{children}</div>;
  }
}

class FluxibleApplication extends React.LegacyComponentWithChildren {
  UNSAFE_componentWillMount() {
    this.fluxibleContext = app.createContext();
  }

  fluxibleContext: Fluxible.Context = {};

  render() {
    return (
      <FluxibleComponent context={this.fluxibleContext.getComponentContext()}>
        <Application {...this.props} />
      </FluxibleComponent>
    );
  }
}

export default FluxibleApplication;
